import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { MoneyString, SumMoney } from 'model/Money'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    items: {
      display: 'flex',
      gap: `${theme.spacing(2)}px`,
    },
  })
)

export const ChildrenSummaryTooltip = (props: {
  data: TargetPriceGraphData
}) => {
  const cn = useStyles()
  const { t } = useTranslation()

  const childrenArray = Object.values(props.data.childrens)
  //   console.log('childrenArray', childrenArray)

  return (
    <div>
      <LocalizedTypography translationKey={`project:${props.data.description}`}>
        {props.data.description}
      </LocalizedTypography>
      <div className={cn.items}>
        <TargetPriceTooltipListItemText
          className={cn.listItem}
          primary={childrenArray.length}
          secondary={t('common:num-items', '# items')}
        />
        <TargetPriceTooltipListItemText
          className={cn.listItem}
          primary={MoneyString(
            SumMoney(childrenArray.map((x) => x.salesPrice))
          )}
          secondary={t('project:price-per-batch')}
        />
      </div>
    </div>
  )
}
